(function () {
  'use strict';

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Liens internes : rester sur welyna.store, jamais le .myshopify.com */
  const localiserLiens = () => {
    document.querySelectorAll('a[href]').forEach((a) => {
      const raw = a.getAttribute('href');
      if (!raw || raw.startsWith('#') || raw.startsWith('mailto:') || raw.startsWith('tel:')) return;
      let url;
      try { url = new URL(raw, location.origin); } catch { return; }
      if (url.origin === location.origin) return;
      if (/wa\.me$|whatsapp\.com$|instagram\.com$/.test(url.hostname.replace(/^www\./, ''))) return;
      if (url.hostname.endsWith('.myshopify.com') || url.hostname === 'welyna.store' || url.hostname === 'www.welyna.store') {
        a.setAttribute('href', url.pathname + url.search + url.hash);
      }
    });
  };
  localiserLiens();

  /* ---- Header scroll ---- */
  const barre = document.getElementById('site-barre');
  const campagne = document.querySelector('.cine-campagne');
  const onScroll = () => {
    if (barre && campagne) {
      barre.classList.toggle('est-jour', window.scrollY > campagne.offsetHeight - 72);
    }
    const max = document.documentElement.scrollHeight - window.innerHeight;
    document.documentElement.style.setProperty('--scroll', max > 0 ? (window.scrollY / max).toFixed(4) : '0');
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---- Hero ciné : rideau + lettres Prisma (21st 12200) ---- */
  const hero = document.querySelector('[data-welyna-hero]');
  if (hero && !hero.classList.contains('cine-campagne')) {
    const mot = hero.querySelector('.cine-geant');
    if (mot && !mot.querySelector('.cine-lettre')) {
      const raw = mot.textContent || '';
      const fills = (hero.getAttribute('data-fills') || '').split('|').filter(Boolean);
      mot.textContent = '';
      Array.from(raw).forEach((ch, i) => {
        const glyph = ch === ' ' ? '\u00a0' : ch;
        const masque = document.createElement('span');
        masque.className = 'cine-lettre-masque';
        const lettre = document.createElement('span');
        lettre.className = 'cine-lettre';
        const base = document.createElement('span');
        base.className = 'cine-lettre-base';
        base.textContent = glyph;
        const fill = document.createElement('span');
        fill.className = 'cine-lettre-fill';
        fill.textContent = glyph;
        fill.setAttribute('aria-hidden', 'true');
        if (fills.length) fill.style.backgroundImage = 'url("' + fills[i % fills.length] + '")';
        lettre.appendChild(base);
        lettre.appendChild(fill);
        masque.appendChild(lettre);
        ['haut', 'milieu', 'bas'].forEach((n) => {
          const volet = document.createElement('span');
          volet.className = 'cine-volet cine-volet-' + n;
          volet.textContent = glyph;
          volet.setAttribute('aria-hidden', 'true');
          masque.appendChild(volet);
        });
        mot.appendChild(masque);
      });
    }
    const ajuster = () => {
      if (!mot) return;
      hero.style.setProperty('--geant-taille', '100px');
      const range = document.createRange();
      range.selectNodeContents(mot);
      const w = range.getBoundingClientRect().width;
      range.detach?.();
      if (!w) return;
      hero.style.setProperty('--geant-taille', ((100 * (hero.clientWidth * 1.04)) / w).toFixed(1) + 'px');
    };
    ajuster();
    document.fonts?.ready.then(ajuster).catch(() => {});
    new ResizeObserver(ajuster).observe(hero);

    if (!reduced && typeof gsap !== 'undefined') {
      const panneaux = hero.querySelectorAll('.cine-panneau');
      const lettres = hero.querySelectorAll('.cine-lettre');
      const suite = hero.querySelectorAll('[data-cine-fondu]');
      const ease = 'power3.out';
      const tl = gsap.timeline({ defaults: { ease, duration: 0.9 } });
      tl.fromTo(panneaux, { xPercent: 0 }, { xPercent: -101, stagger: 0.11, duration: 0.95 })
        .from(lettres, { yPercent: 120, stagger: 0.045, duration: 0.7, ease: 'power3.out', clearProps: 'transform' }, '-=0.4')
        .from(suite, { autoAlpha: 0, y: 24, stagger: 0.1, duration: 0.7, clearProps: 'transform,opacity,visibility' }, '-=0.45');

      hero.querySelectorAll('.cine-lettre-masque').forEach((m, i) => {
        const haut = m.querySelector('.cine-volet-haut');
        const mil = m.querySelector('.cine-volet-milieu');
        const bas = m.querySelector('.cine-volet-bas');
        if (!haut || !mil || !bas) return;
        gsap.timeline({ delay: 0.85 + i * 0.04 })
          .fromTo(haut, { xPercent: -110, opacity: 0 }, { xPercent: 110, opacity: 1, duration: 0.55, ease: 'power2.inOut' })
          .fromTo(mil, { xPercent: 110, opacity: 0 }, { xPercent: -110, opacity: 1, duration: 0.55, ease: 'power2.inOut' }, 0.08)
          .fromTo(bas, { xPercent: -110, opacity: 0 }, { xPercent: 110, opacity: 1, duration: 0.55, ease: 'power2.inOut' }, 0.14)
          .set([haut, mil, bas], { autoAlpha: 0 });
      });
    }
  }

  /* ---- Menu plein écran ---- */
  const menuToggle = document.getElementById('menu-toggle');
  const menuWrap = document.getElementById('menu-welyna');
  if (menuToggle && menuWrap) {
    const imgs = menuWrap.querySelectorAll('.menu-fond-image');
    const video = menuWrap.querySelector('.menu-fond-video');

    function estOuvert() {
      return document.documentElement.classList.contains('menu-ouvert');
    }

    function setOuvert(v) {
      const ouvert = Boolean(v);
      const wasOpen = estOuvert();
      document.documentElement.classList.toggle('menu-ouvert', ouvert);
      menuToggle.setAttribute('aria-expanded', String(ouvert));
      document.getElementById('MainContent')?.toggleAttribute('inert', ouvert);
      document.querySelector('.pied')?.toggleAttribute('inert', ouvert);
      if (video) {
        if (ouvert && !reduced) {
          video.preload = 'auto';
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      }
      if (ouvert) {
        menuWrap.querySelector('.menu-liste a')?.focus();
      } else if (wasOpen) {
        menuToggle.focus();
      }
      if (ouvert && !reduced && typeof gsap !== 'undefined') {
        const mots = menuWrap.querySelectorAll('.menu-lien-masque');
        const arabes = menuWrap.querySelectorAll('.menu-lien-arabe');
        gsap.fromTo(mots, { yPercent: 110 }, { yPercent: 0, duration: 0.7, stagger: 0.07, ease: 'power3.out' });
        gsap.fromTo(arabes, { opacity: 0, x: -12 }, { opacity: 1, x: 0, duration: 0.6, stagger: 0.07, delay: 0.12, ease: 'power3.out' });
      }
    }

    menuWrap.querySelectorAll('[data-menu-close]').forEach((el) => {
      el.addEventListener('click', () => setOuvert(false));
    });
    menuWrap.querySelectorAll('.menu-lien').forEach((lien) => {
      lien.addEventListener('click', () => setOuvert(false));
    });
    menuWrap.querySelectorAll('.menu-lien-masque > span').forEach((el) => {
      if (el.classList.contains('est-roll')) return;
      if (el.classList.contains('drop-new')) return;
      const raw = el.textContent || '';
      el.textContent = '';
      el.classList.add('est-roll');
      const a = document.createElement('span');
      a.className = 'roll-a';
      const b = document.createElement('span');
      b.className = 'roll-b';
      b.setAttribute('aria-hidden', 'true');
      Array.from(raw).forEach((ch, i) => {
        const glyph = ch === ' ' ? '\u00a0' : ch;
        const sa = document.createElement('span');
        sa.style.setProperty('--i', String(i));
        sa.textContent = glyph;
        a.appendChild(sa);
        const sb = document.createElement('span');
        sb.style.setProperty('--i', String(i));
        sb.textContent = glyph;
        b.appendChild(sb);
      });
      el.appendChild(a);
      el.appendChild(b);
    });

    menuWrap.querySelectorAll('.menu-lien').forEach((lien, i) => {
      lien.closest('li')?.addEventListener('mouseenter', () => {
        imgs.forEach((el, k) => {
          el.style.opacity = i === k ? '1' : '0';
          el.style.transform = i === k ? 'scale(1.08)' : 'scale(1.02)';
        });
      });
    });

    menuToggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      setOuvert(!estOuvert());
    });

    window.addEventListener('keydown', (e) => {
      if (!estOuvert()) return;
      if (e.key === 'Escape') {
        setOuvert(false);
        return;
      }
      if (e.key !== 'Tab') return;
      const cibles = Array.from(menuWrap.querySelectorAll('a, button')).filter((el) => !el.hasAttribute('disabled'));
      if (!cibles.length) return;
      const first = cibles[0];
      const last = cibles[cibles.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  /* ---- Chapitres vidéo (lazy attach + play/pause) ---- */
  document.querySelectorAll('[data-welyna-chap]').forEach((section, idx) => {
    const video = section.querySelector('.chap-video');
    if (!video || reduced) return;

    const landscape = section.dataset.videoLandscape;
    const portrait = section.dataset.videoPortrait;
    let attache = idx === 0;
    let joue = false;

    const mettreSource = () => {
      if (video.querySelector('source')) return;
      if (portrait) {
        const sP = document.createElement('source');
        sP.src = portrait;
        sP.type = 'video/mp4';
        sP.media = '(max-width: 767px)';
        video.appendChild(sP);
      }
      const sL = document.createElement('source');
      sL.src = landscape;
      sL.type = 'video/mp4';
      video.appendChild(sL);
      video.load();
    };

    const syncPlay = () => {
      if (!attache) return;
      if (joue) video.play().catch(() => {});
      else video.pause();
    };

    video.addEventListener('canplay', () => {
      video.classList.add('est-prete');
      if (joue) video.play().catch(() => {});
    });

    if (attache) mettreSource();

    const attacheur = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          attache = true;
          mettreSource();
          attacheur.disconnect();
        }
      },
      { rootMargin: '100% 0px' }
    );

    const lecteur = new IntersectionObserver(
      ([e]) => {
        joue = e.isIntersecting;
        syncPlay();
      },
      { threshold: 0.15 }
    );

    if (!attache) attacheur.observe(section);
    lecteur.observe(section);
  });

  /* ---- Deck avis ---- */
  const deck = document.getElementById('avis-deck');
  if (deck) {
    const cartes = Array.from(deck.querySelectorAll('.deck-carte'));
    const total = cartes.length;
    let index = 0;
    let sortieX = 0;
    const currentEl = deck.querySelector('[data-avis-current]');
    const btnPrev = deck.querySelector('[data-avis-prev]');
    const btnNext = deck.querySelector('[data-avis-next]');

    const render = (animer = true) => {
      cartes.forEach((carte, i) => {
        const rang = (i - index + total) % total;
        carte.style.zIndex = String(3 - rang);
        carte.setAttribute('aria-hidden', rang === 0 ? 'false' : 'true');
        carte.style.display = rang > 2 ? 'none' : '';
        const dessus = rang === 0;
        carte.style.transform = dessus
          ? `translateX(${sortieX}px) translateY(0) rotate(${sortieX / 22}deg) scale(1)`
          : `translateX(0) translateY(${rang * 10}px) rotate(${rang === 1 ? -1.6 : -3.2}deg) scale(${1 - rang * 0.04})`;
        carte.style.opacity = dessus ? '1' : rang === 1 ? '0.55' : '0.28';
        /* Pendant le drag : aucune transition — la carte est collée au doigt.
           La transition ne revient qu'au lâcher, pour le départ ou le retour. */
        carte.style.transition = animer
          ? 'transform 0.34s cubic-bezier(0.23, 1, 0.32, 1), opacity 0.34s ease'
          : 'none';
      });
      if (currentEl) currentEl.textContent = String(index + 1);
    };

    /* Le témoignage se révèle mot à mot, du flou au net, à chaque changement
       de carte — pattern « blur reveal ». Le texte reste entier pour les
       lecteurs d'écran via aria-label ; les mots animés sont décoratifs. */
    const animerTexte = (carte) => {
      if (reduced || !carte) return;
      const quote = carte.querySelector('blockquote');
      if (!quote) return;
      if (!quote.dataset.brut) quote.dataset.brut = (quote.textContent || '').trim();
      const brut = quote.dataset.brut;
      quote.setAttribute('aria-label', brut);
      quote.textContent = '';
      const wrap = document.createElement('span');
      wrap.setAttribute('aria-hidden', 'true');
      brut.split(/\s+/).forEach((mot, i) => {
        const s = document.createElement('span');
        s.className = 'deck-mot';
        s.style.animationDelay = (i * 22) + 'ms';
        s.textContent = mot;
        wrap.appendChild(s);
        wrap.appendChild(document.createTextNode(' '));
      });
      quote.appendChild(wrap);
    };

    const aller = (pas) => {
      index = (index + pas + total) % total;
      sortieX = 0;
      render();
      animerTexte(cartes[index]);
    };

    /* Un lancer suffit : la vélocité compte autant que la distance.
       Seuil ~0.11 px/ms — un flick rapide de quelques pixels dégage la carte. */
    const finGeste = (dx, velocite) => {
      const lance = Math.abs(velocite) > 0.35;
      if (!lance && Math.abs(dx) <= 100) return;
      const sens = (lance ? velocite : dx) < 0 ? 1 : -1;
      sortieX = sens === 1 ? -window.innerWidth : window.innerWidth;
      render();
      setTimeout(() => aller(sens), 340);
    };

    btnPrev?.addEventListener('click', () => aller(-1));
    btnNext?.addEventListener('click', () => aller(1));
    deck.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); aller(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); aller(1); }
    });

    let dragX = 0;
    let dragging = false;
    let trace = [];
    const pile = deck.querySelector('.deck-pile');
    if (pile) {
      pile.addEventListener('pointerdown', (e) => {
        if (e.target.closest('.deck-commandes')) return;
        dragging = true;
        dragX = e.clientX;
        trace = [{ x: e.clientX, t: performance.now() }];
        pile.setPointerCapture(e.pointerId);
      });
      pile.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        sortieX = e.clientX - dragX;
        trace.push({ x: e.clientX, t: performance.now() });
        if (trace.length > 6) trace.shift();
        render(false);
      });
      pile.addEventListener('pointerup', () => {
        if (!dragging) return;
        dragging = false;
        let velocite = 0;
        if (trace.length > 1) {
          const premier = trace[0];
          const dernier = trace[trace.length - 1];
          const dt = dernier.t - premier.t;
          if (dt > 0) velocite = (dernier.x - premier.x) / dt;
        }
        finGeste(sortieX, velocite);
        sortieX = 0;
        render();
      });
    }

    render();
  }

  /* ---- Route panneaux ---- */
  document.querySelectorAll('[data-route-panneaux]').forEach((wrap) => {
    const panneaux = wrap.querySelectorAll('.route-panneau');
    const ouvrir = (i) => {
      panneaux.forEach((p, k) => p.classList.toggle('est-ouvert', k === i));
    };
    panneaux.forEach((p, i) => {
      p.addEventListener('mouseenter', () => ouvrir(i));
      p.addEventListener('focus', () => ouvrir(i));
      p.addEventListener('click', () => ouvrir(i));
    });
  });

  /* ---- Barre achat mobile ---- */
  const barreAchat = document.querySelector('.barre-achat');
  const ctaReel = document.querySelector('[data-cta-reel]');
  if (barreAchat && ctaReel) {
    const io = new IntersectionObserver(
      ([e]) => {
        barreAchat.classList.toggle('est-visible', !e.isIntersecting);
        barreAchat.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      },
      { threshold: 0 }
    );
    io.observe(ctaReel);
  }

  /* ---- Faits : entrée au scroll ---- */
  if (!reduced) {
    document.querySelectorAll('.faits-carte').forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(18px)';
      el.style.transition = `opacity 0.28s cubic-bezier(0.23, 1, 0.32, 1) ${i * 0.06}s, transform 0.28s cubic-bezier(0.23, 1, 0.32, 1) ${i * 0.06}s`;
      const obs = new IntersectionObserver(
        ([e]) => {
          if (e.isIntersecting) {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
            obs.disconnect();
          }
        },
        { rootMargin: '-80px' }
      );
      obs.observe(el);
    });
  }

  /* ---- 21st : boutons + cartes + menu + hero + chapitres ---- */
  if (!document.querySelector('.welyna-progress')) {
    const bar = document.createElement('div');
    bar.className = 'welyna-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
  }

  const prismaCibles = document.querySelectorAll(
    '.pill, .btn, .fiche-cta, .fiche-cta-second, .chap-action, .btn-ink, .btn-ghost, .barre-achat-cta'
  );
  prismaCibles.forEach((el) => {
    el.querySelectorAll('span[aria-hidden="true"]').forEach((s) => {
      if (s.classList.contains('pill-disque')) return;
      if (/^[→←]\s*$/.test((s.textContent || '').trim())) s.remove();
    });
    if (!el.querySelector('.pill-disque')) {
      const d = document.createElement('span');
      d.className = 'pill-disque';
      d.setAttribute('aria-hidden', 'true');
      d.textContent = '→';
      el.appendChild(d);
    }
  });

  const pointeurFin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (pointeurFin && !reduced) {
    document.documentElement.classList.add('welyna-21st');

    let mx = window.innerWidth / 2;
    let my = window.innerHeight / 2;
    const magnets = [];

    const magnetiser = (nodes, opts) => {
      Array.from(nodes).forEach((el) => {
        if (!el || magnets.some((m) => m.el === el)) return;
        magnets.push({
          el,
          disc: opts.disc ? el.querySelector('.pill-disque') : null,
          pull: opts.pull,
          reach: opts.reach,
          discN: opts.discN || 0.55,
          x: 0,
          y: 0,
          tx: 0,
          ty: 0,
          dx: 0,
          dy: 0,
          tdx: 0,
          tdy: 0,
        });
      });
    };

    /* Les boutons ne bougent pas : ils changent d'état. Le magnétisme est
       réservé aux rares éléments décoratifs (logo, menu, pied, cartes) —
       un bouton qu'on survole dix fois par visite doit rester posé. */
    magnetiser(document.querySelectorAll('.menu-lien'), { pull: 0.16, reach: 160 });
    magnetiser(document.querySelectorAll('.site-marque'), { pull: 0.18, reach: 120 });
    magnetiser(document.querySelectorAll('.pied-liens a, .pied-icon, .pied-logo-lien'), { pull: 0.2, reach: 90 });
    magnetiser(document.querySelectorAll('.faits-surface'), { pull: 0.14, reach: 150 });

    const holes = Array.from(document.querySelectorAll('.carte-media')).map((el) => {
      const img = el.querySelector('.carte-media-2');
      return img
        ? {
            el,
            img,
            x: el.clientWidth / 2,
            y: el.clientHeight / 2,
            r: 0,
            tx: el.clientWidth / 2,
            ty: el.clientHeight / 2,
            open: false,
          }
        : null;
    }).filter(Boolean);

    const origins = Array.from(document.querySelectorAll('.faits-carte, .carte-media'));
    const boards = Array.from(document.querySelectorAll('.bandeau, .route-panneau'));
    const follows = [];
    const suivre = (el, amount, scale) => {
      if (!el) return;
      follows.push({ el, amount, scale: scale || 1.08, x: 0, y: 0, tx: 0, ty: 0 });
    };
    suivre(document.querySelector('.cine-video'), 22, 1.1);
    document.querySelectorAll('.chap-video, .js-suivre').forEach((el) => suivre(el, 16, 1.08));

    document.addEventListener(
      'pointermove',
      (e) => {
        mx = e.clientX;
        my = e.clientY;

        magnets.forEach((m) => {
          const b = m.el.getBoundingClientRect();
          const dx = mx - (b.left + b.width / 2);
          const dy = my - (b.top + b.height / 2);
          const dist = Math.hypot(dx, dy);
          if (dist < m.reach) {
            const s = (1 - dist / m.reach) * m.pull;
            m.tx = dx * s;
            m.ty = dy * s;
            m.tdx = dx * s * m.discN;
            m.tdy = dy * s * m.discN;
          } else {
            m.tx = 0;
            m.ty = 0;
            m.tdx = 0;
            m.tdy = 0;
          }
          m.el.style.setProperty('--lx', (((mx - b.left) / b.width) * 100).toFixed(1) + '%');
          m.el.style.setProperty('--ly', (((my - b.top) / b.height) * 100).toFixed(1) + '%');
        });

        holes.forEach((h) => {
          const b = h.el.getBoundingClientRect();
          const inside = mx >= b.left && mx <= b.right && my >= b.top && my <= b.bottom;
          if (inside) {
            if (!h.open) {
              h.tx = mx - b.left;
              h.ty = my - b.top;
              h.open = true;
            }
            h.tr = Math.hypot(b.width, b.height) * 1.12;
          } else {
            h.open = false;
            h.tr = 0;
          }
        });

        origins.forEach((el) => {
          const b = el.getBoundingClientRect();
          if (mx < b.left || mx > b.right || my < b.top || my > b.bottom) return;
          el.style.setProperty('--ox', (((mx - b.left) / b.width) * 100).toFixed(1) + '%');
          el.style.setProperty('--oy', (((my - b.top) / b.height) * 100).toFixed(1) + '%');
        });

        boards.forEach((el) => {
          const b = el.getBoundingClientRect();
          if (mx < b.left || mx > b.right || my < b.top || my > b.bottom) return;
          el.style.setProperty('--bx', (50 + ((mx - b.left) / b.width - 0.5) * 14).toFixed(1) + '%');
          el.style.setProperty('--by', (42 + ((my - b.top) / b.height - 0.5) * 14).toFixed(1) + '%');
          el.style.setProperty('--mx', (((mx - b.left) / b.width) * 100).toFixed(1) + '%');
          el.style.setProperty('--my', (((my - b.top) / b.height) * 100).toFixed(1) + '%');
        });

        follows.forEach((f) => {
          const b = f.el.getBoundingClientRect();
          const inside = mx >= b.left && mx <= b.right && my >= b.top && my <= b.bottom;
          if (inside) {
            f.tx = ((mx - (b.left + b.width / 2)) / b.width) * f.amount;
            f.ty = ((my - (b.top + b.height / 2)) / b.height) * f.amount;
          } else {
            f.tx = 0;
            f.ty = 0;
          }
        });
      },
      { passive: true }
    );

    const tick = () => {
      magnets.forEach((m) => {
        m.x += (m.tx - m.x) * 0.22;
        m.y += (m.ty - m.y) * 0.22;
        m.dx += (m.tdx - m.dx) * 0.28;
        m.dy += (m.tdy - m.dy) * 0.28;
        m.el.style.transform =
          'translate3d(' + m.x.toFixed(2) + 'px,' + m.y.toFixed(2) + 'px,0)';
        if (m.disc) {
          m.disc.style.transform =
            'translate3d(' + m.dx.toFixed(2) + 'px,' + m.dy.toFixed(2) + 'px,0) rotate(' + (m.dx * 0.4).toFixed(1) + 'deg)';
        }
      });

      holes.forEach((h) => {
        h.x += (h.tx - h.x) * 0.18;
        h.y += (h.ty - h.y) * 0.18;
        h.r += (h.tr - h.r) * 0.22;
        h.img.style.clipPath =
          'circle(' + Math.max(0, h.r).toFixed(1) + 'px at ' + h.x.toFixed(1) + 'px ' + h.y.toFixed(1) + 'px)';
      });

      follows.forEach((f) => {
        f.x += (f.tx - f.x) * 0.12;
        f.y += (f.ty - f.y) * 0.12;
        f.el.style.transform =
          'translate3d(' + f.x.toFixed(2) + 'px,' + f.y.toFixed(2) + 'px,0) scale(' + f.scale + ')';
      });

      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  /* ---- L'index : la photo suit le curseur au-dessus de la liste ---- */
  const indexWrap = document.querySelector('[data-welyna-index]');
  if (indexWrap) {
    const apercu = indexWrap.parentElement.querySelector('.idx-apercu');
    const apercuImg = apercu ? apercu.querySelector('img') : null;
    const fin = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (apercu && apercuImg && fin && !reduced) {
      let ax = 0, ay = 0, tx = 0, ty = 0, visible = false, tourne = false;

      const tick = () => {
        ax += (tx - ax) * 0.14;
        ay += (ty - ay) * 0.14;
        apercu.style.transform = visible
          ? 'translate3d(' + ax.toFixed(1) + 'px,' + ay.toFixed(1) + 'px,0) scale(1)'
          : 'translate3d(' + ax.toFixed(1) + 'px,' + ay.toFixed(1) + 'px,0) scale(0.96)';
        if (visible || Math.abs(tx - ax) > 0.5) requestAnimationFrame(tick);
        else tourne = false;
      };
      const demarrer = () => { if (!tourne) { tourne = true; requestAnimationFrame(tick); } };

      indexWrap.addEventListener('pointermove', (e) => {
        tx = e.clientX + 28;
        ty = e.clientY - 200;
        if (visible) demarrer();
      }, { passive: true });

      indexWrap.querySelectorAll('.idx-ligne').forEach((ligne) => {
        ligne.addEventListener('pointerenter', () => {
          const src = ligne.getAttribute('data-idx-src');
          if (src && apercuImg.getAttribute('src') !== src) apercuImg.setAttribute('src', src);
          visible = true;
          apercu.classList.add('est-visible');
          demarrer();
        });
        ligne.addEventListener('pointerleave', () => {
          visible = false;
          apercu.classList.remove('est-visible');
        });
      });
    }
  }

  /* ---- Consentement cookies — bandeau signé Welyna ---- */
  const consentRoot = document.getElementById('consent-welyna');
  if (consentRoot) {
    const CLE = 'welyna-consent';
    const cp = () => (window.Shopify && window.Shopify.customerPrivacy) || null;

    const enregistrer = (choix) => {
      try { localStorage.setItem(CLE, choix); } catch (e) {}
      const api = cp();
      if (api && typeof api.setTrackingConsent === 'function') {
        const tout = choix === 'all';
        try {
          api.setTrackingConsent(
            { analytics: tout, marketing: tout, preferences: tout, sale_of_data: false },
            () => {}
          );
        } catch (e) {}
      }
      document.documentElement.dispatchEvent(new CustomEvent('welyna:consent', { detail: choix }));
    };

    const fermer = () => {
      if (reduced) {
        consentRoot.hidden = true;
      } else {
        consentRoot.classList.add('est-sorti');
        consentRoot.addEventListener('transitionend', () => { consentRoot.hidden = true; }, { once: true });
      }
      consentRoot.classList.remove('est-ouvert');
    };

    const ouvrir = () => {
      consentRoot.hidden = false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => consentRoot.classList.add('est-ouvert'));
      });
      const premier = consentRoot.querySelector('[data-consent="all"]');
      if (premier) premier.focus({ preventScroll: true });
    };

    const decision = () => {
      try { return localStorage.getItem(CLE); } catch (e) { return null; }
    };

    consentRoot.querySelectorAll('[data-consent]').forEach((btn) => {
      btn.addEventListener('click', () => {
        enregistrer(btn.getAttribute('data-consent'));
        fermer();
      });
    });

    consentRoot.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        enregistrer('essential');
        fermer();
      }
    });

    document.querySelectorAll('[data-consent-open]').forEach((btn) => {
      btn.addEventListener('click', () => {
        try { localStorage.removeItem(CLE); } catch (e) {}
        ouvrir();
      });
    });

    if (!decision()) {
      setTimeout(ouvrir, reduced ? 0 : 1200);
    }
  }

  /* Lookbook défilé — 21st Horizontal Scroll Gallery, native */
  document.querySelectorAll('[data-welyna-defile]').forEach((root) => {
    const wrap = root.querySelector('.defile-wrap');
    const track = root.querySelector('.defile-track');
    if (!wrap || !track) return;
    if (reduced) return;
    const maj = () => {
      const extra = Math.max(1, track.scrollWidth - window.innerWidth);
      wrap.style.height = (window.innerHeight + extra) + 'px';
      const range = wrap.offsetHeight - window.innerHeight;
      const scrolled = Math.max(0, Math.min(range, -wrap.getBoundingClientRect().top));
      const p = range > 0 ? scrolled / range : 0;
      track.style.transform = 'translate3d(' + (-p * extra) + 'px,0,0)';
    };
    window.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(maj).catch(() => {});
    maj();
  });

  /* Atelier matières — 21st Scroll 01, native */
  document.querySelectorAll('[data-welyna-atelier]').forEach((root) => {
    const imgs = Array.from(root.querySelectorAll('[data-atelier-media]'));
    const etapes = Array.from(root.querySelectorAll('[data-atelier-etape]'));
    if (!imgs.length || !etapes.length) return;
    if (window.matchMedia('(max-width: 900px)').matches) {
      imgs.forEach((img, i) => img.classList.toggle('est-actif', i === 0));
      etapes.forEach((el) => el.classList.add('est-actif'));
      return;
    }
    const activer = (i) => {
      imgs.forEach((img, j) => img.classList.toggle('est-actif', j === i));
      etapes.forEach((el, j) => el.classList.toggle('est-actif', j === i));
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const i = etapes.indexOf(entry.target);
        if (i >= 0) activer(i);
      });
    }, { threshold: 0.55, rootMargin: '-10% 0px -25% 0px' });
    etapes.forEach((el) => io.observe(el));
  });

  if (!reduced && typeof gsap !== 'undefined') {
    document.querySelectorAll('.chap-titre, .bandeau-titre, .titre-page, .faits-titre, .route-titre, .h2b, .defile-titre, .atelier-titre, .empile-titre').forEach((el) => {
      gsap.set(el, { y: 36, opacity: 0, filter: 'blur(8px)' });
      const obs = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;
          gsap.fromTo(
            el,
            { y: 36, opacity: 0, filter: 'blur(8px)' },
            { y: 0, opacity: 1, filter: 'blur(0px)', duration: 0.7, ease: 'power3.out', clearProps: 'filter' }
          );
          obs.disconnect();
        },
        { threshold: 0.28 }
      );
      obs.observe(el);
    });
  }
})();
